const BASE_URL =
    'https://game-elements-exports.s3.eu-west-1.amazonaws.com/thumbnails';

const DEFAULT_SIZE = 32;

interface GameElementIconProps {
    gameElementId: string;
    size?: number;
}

export const GameElementIcon = ({
    gameElementId,
    size = DEFAULT_SIZE,
}: GameElementIconProps) => {
    return (
        <img
            loading="lazy"
            width={size}
            height={size}
            src={`${BASE_URL}/${gameElementId}.png`}
        />
    );
};
